import z from "zod";
import { defineObject } from "sanity-typed-queries";
import requiredImage from "../fragments/requiredImage.js";
var schema = defineObject("seoFields", {
    focusKeyphrase: {
        title: "Focus Keyphrase",
        type: "string",
        description: "More info: https://yoast.com/focus-keyword"
    },
    keyphraseSynonyms: {
        title: "Keyphrase Synonyms",
        type: "string",
        description: "More info: https://yoast.com/help/yoast-seo-glossary/#synonyms"
    },
    seoTitle: {
        title: "SEO Title",
        type: "string"
    },
    seoImage: {
        title: "SEO Image",
        type: "image",
        options: requiredImage.fragment.options
    },
    metaDescription: {
        title: "Meta Description",
        type: "text"
    },
    hidePageFromSearchEngines: {
        title: "Hide page from search engines",
        type: "boolean"
    }
});
var validator = z.object({
    focusKeyphrase: z.string(),
    keyphraseSynonyms: z.string(),
    seoTitle: z.string(),
    seoImage: requiredImage.validator,
    metaDescription: z.string()
}).partial();
schema.seoFields;
export default {
    schema: schema,
    validator: validator
};

//# sourceMappingURL=seoFields.js.map